<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, computed, } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import VerificationCode from '@/components/cloudCounter/VerificationCode.vue';

import { useRouter } from 'vue-router';
const router = useRouter();

const goNextPage = () => {
    router.push({ name: 'cloudCounterVideoOperationOcrId' });
};


//邀請碼
const inviteCode = ref('');

//驗證碼
const verifyCode = ref('');

//倒數中
const isCounting = ref(false);
const beginCounting = () => {
    isCounting.value = true;
    verifyCode.value = '';
}
const stopCounting = () => {
    isCounting.value = false;
}

</script>

<template>

    <Layout :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="2"></Process>
        </div>

        <div class="pb-4">
            <h2 class="font-bold text-2xl pb-2">
                視訊驗證
            </h2>
            <p>請先輸入邀請碼，再點選發送邀請碼輸入動態密碼</p>
        </div>

        <div class="pb-4">
            <h3 class="font-bold text-xl pb-2">輸入邀請碼</h3>
            <input type="text" placeholder="請輸入邀請碼" v-model="inviteCode" />
        </div>

        <div class="pb-4">

            <VerificationCode 
                :buttonDisabled="inviteCode === '' || isCounting" 
                :beginCounting="beginCounting" 
                :stopCounting="stopCounting" 
            >
                <input type="text" placeholder="請輸入 6 碼動態密碼" maxlength="6" size="6" :disabled="inviteCode === ''"
                v-model="verifyCode" />                
            </VerificationCode>
    
        </div> 

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="isCounting ? (inviteCode === '' || verifyCode === '') : true" @click="goNextPage">確認</button>
        </template>

    </Layout>

</template>

<style scoped></style>
